<template>
  <v-card>
    <v-card-title>Scan</v-card-title>
    <v-card-text>
      <v-text-field
        v-model="filter"
        append-icon="mdi-barcode-scan"
        @click:append="getItem"
        :label="scanLabel"
        single-line
        hide-details
        @keyup.enter="getItem">
      </v-text-field>

      <v-radio-group v-model="selectedScanMode">
        <v-radio v-for="scanOption in availableScanModes" :key="scanOption.value" :label="scanOption.text" :value="scanOption.value"></v-radio>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ScanItem',

  data: () => ({
    filter: '',
    selectedScanMode: 'normal',
    availableScanModes: [
      { text: 'Normal', value: 'normal' },
      { text: 'Old School (BoxPN + BoxID)', value: 'oldSchool' }
    ],
    scanLabel: 'serialNumber / casingId / imsi / iccid / boxPn / boxSn'
  }),

  methods: {
    async getItem () {
      console.log('getItem triggered')
      console.log('selected scan mode: ' + this.selectedScanMode)

      let query
      if (this.selectedScanMode === 'normal') {
        query = '?filter=' + this.filter
      }
      if (this.selectedScanMode === 'oldSchool') {
        const boxPn = this.filter.split('##')[0]
        const boxId = this.filter.split('##')[1]
        query = '?boxPn=' + boxPn + '&boxId=' + boxId
      }

      let result
      try {
        result = await axios.get(process.env.VUE_APP_API_URL + '/items' + query)
      } catch (err) {
        console.error('Error trying to getItem axios.get()', err)
      }

      for (let i = 0; i < result.data.length; i++) {
        this.$emit('foundItem', result.data[i])
      }
      this.filter = ''
      console.log('result:', result.data)
    }
  },

  watch: {
    selectedScanMode (val) {
      if (val === 'normal') {
        this.scanLabel = 'serialNumber / casingId / imsi / iccid / boxPn / boxSn'
      }
      if (val === 'oldSchool') {
        this.scanLabel = 'boxPn##boxId'
      }
    }
  }
}
</script>

<style>

</style>
